import { UserTypes } from "src/modules/Auth/store/types";
import { IRouteAuth } from "src/modules/Routing/types";

export const validateAuthentication = (userType: UserTypes, policies: UserTypes[]): IRouteAuth => {
  if (policies.length === 0) {
    return {
      private: false,
      authorized: true,
    };
  }
  const isAuthenticated = userType !== UserTypes.UNAUTH;
  const authorized = !!policies.find((policy) => policy === userType);
  return {
    private: true,
    authorized,
    ...isAuthenticated && !authorized ? { forbidden: true } : {},
  };
}